import { render, staticRenderFns } from "./EarningsCurrency.vue?vue&type=template&id=230ad6ae&"
import script from "./EarningsCurrency.vue?vue&type=script&lang=js&"
export * from "./EarningsCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports